import { ReactNode } from 'react';
import { AlertProps } from '@mui/material';
import { atom } from 'jotai';

export interface IAlert {
    id: string;
    message: ReactNode;
    title?: string;
    severity?: AlertProps['severity'];
}

export const alertsAtom = atom<IAlert[]>([]);
